import { questionType, typeMapping } from '@dygc/question'
import { personalInfo } from '@/assets/js/config/question-type'

export const types = [
  {
    label: '选择题',
    values: [
      {
        label: typeMapping.get(questionType.SINGLE_CHOICE),
        value: questionType.SINGLE_CHOICE,
        icon: 'icon-danxuanti'
      },
      {
        label: typeMapping.get(questionType.MULTIPLE_CHOICE),
        value: questionType.MULTIPLE_CHOICE,
        icon: 'icon-duoxuanti'
      },
      {
        label: typeMapping.get(questionType.SINGLE_SELECT),
        value: questionType.SINGLE_SELECT,
        icon: 'icon-xialati'
      },
      {
        label: typeMapping.get(questionType.LINKAGE),
        value: questionType.LINKAGE,
        icon: 'icon-jilianti'
      },
      {
        label: typeMapping.get(questionType.IMAGE_CHOICE),
        value: questionType.IMAGE_CHOICE,
        icon: 'icon-tupianxuanze'
      }
    ]
  },
  {
    label: '文本题',
    values: [
      {
        label: typeMapping.get(questionType.SINGLE_TEXT_FILL),
        value: questionType.SINGLE_TEXT_FILL,
        icon: 'icon-wenbenti'
      }
    ]
  },
  {
    label: '备注说明',
    values: [
      {
        label: typeMapping.get(questionType.ONLY_TEXT),
        value: questionType.ONLY_TEXT,
        icon: 'icon-miaoshu'
      }
    ]
  },
  {
    label: '个人信息',
    values: personalInfo,
    meta: {
      tips: '添加个人信息题，快速收集样本信息，用于回收答卷统计分析',
      icon: 'iconfont icon-shuoming text-theme-black-350 cursor-pointer',
      // isNewFeat: true
    }
  },
  {
    label: '特定格式',
    values: [
      {
        label: typeMapping.get(questionType.DATE),
        value: questionType.DATE,
        icon: 'icon-riqiti'
      },
      {
        label: typeMapping.get(questionType.UPLOAD_FILE),
        value: questionType.UPLOAD_FILE,
        icon: 'icon-wenjianshangchuan'
      },
      {
        label: typeMapping.get(questionType.HANDWRITING),
        value: questionType.HANDWRITING,
        icon: 'icon-shouxieqianming'
      },
      {
        label: typeMapping.get(questionType.CITY_ADDRESS),
        value: questionType.CITY_ADDRESS,
        icon: 'icon-dizhi'
      },
      {
        label: typeMapping.get(questionType.MAP),
        value: questionType.MAP,
        icon: 'icon-diliweizhi'
      },
      {
        label: typeMapping.get(questionType.PHONE_VALIDATE),
        value: questionType.PHONE_VALIDATE,
        icon: 'icon-shoujiyanzheng'
      },
      {
        label: typeMapping.get(questionType.CASCADE_REGION),
        value: questionType.CASCADE_REGION,
        icon: 'icon-hangzhengquhua'
      },
      {
        label: typeMapping.get(questionType.DOWNLOADABLE),
        value: questionType.DOWNLOADABLE,
        icon: 'icon-kexiazaifujian'
      }
    ]
  }
]
